export const NOMBRE_CARPETA_DOMINIO = "pwa";
export const NOMBRE_APP = "Geo App - Finca Danubio";
export const NOMBRE_CORTO = "GeoApp";